import { ROLES } from '@/constants/roles';

export const analytics = {
  path: '/analytic/reports',
  component: () => import('./views/reports-view.vue'),
  meta: {
    title: 'Аналитика',
    layout: 'ui-design',
    icon: 'mdi-chart-arc',
    accessList: [ROLES.operator, ROLES.department],
  },
};

export const uiAnalytics = {
  path: '/ui-analytic',
  name: 'ui-analytic',
  component: () => import('./views/reports-view.vue'),
  meta: {
    title: 'Аналитика',
    layout: 'ui-design',
    accessList: [ROLES.operator, ROLES.department],
  },
  props: {
    hideTitle: true,
  },
};

export default [
  analytics,
  uiAnalytics,
];
